<template>
	<div class="body body-privacy">
		<div class="container bg-privacy" style="padding-top: 30px;">
			<div class="row">
				<div class="col-12 col-md-8 offset-md-2">
					<h1 class="font-weight-bolder">Privacy Notice for California Residents</h1>
				</div>
			</div>
		</div>
		<div class="container bg-privacy">
			<div class="row">
				<div class="col-12 col-md-8 offset-md-2">
					<p>This notice supplements the information contained in our privacy disclosure and applies solely to all visitors, users, and others who reside in the State of California (“consumers” or “you”). We adopt this notice to comply with the California Consumer Privacy Act of 2018 (CCPA), and any terms defined in the CCPA have the same meaning when used in this notice.</p>
          <h6>Information We Collect</h6>
          <p>We collect information that identifies, relates to, describes, references, is capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer or device (“<strong>personal information</strong>”). In particular, we have collected the following categories of personal information from consumers within the last twelve (12) months:</p>
					<br>
          <p><strong>Category A:</strong> Identifiers</p>
          <p><strong>Examples:</strong> A real name, Internet Protocol address, email address, or other similar identifiers.</p>
          <p><strong>Collected:</strong> YES</p>
          <br>
          <p><strong>Category B:</strong> Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).</p>
          <p><strong>Examples:</strong> A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver’s license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information. Some personal information included in this category may overlap with other categories.</p>
          <p><strong>Collected:</strong> YES</p>
          <br>
          <p><strong>Category C:</strong> Protected classification characteristics under California or federal law.</p>
          <p><strong>Examples:</strong> Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth, and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic information).</p>
          <p><strong>Collected:</strong> NO</p>
          <br>
          <p>Personal information does not include:</p>
          <ul>
            <li>Publicly available information from government records.</li>
            <li>De-identified or aggregated consumer information.</li>
            <li>Information excluded from the CCPA’s scope, like:</li>
            <ul>
              <li class="circle">health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the California Confidentiality of Medical Information Act (CMIA) or clinical trial data;</li>
              <li class="circle">personal information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FRCA), the Gramm -Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and the Driver’s Privacy Protection Act of 1994.</li>
            </ul>
          </ul>

          <p>We obtain the categories of personal information listed above from the following categories of sources:</p>
          <ul>
            <li>Directly from you. For example, from forms, you complete on our website.</li>
            <li>Indirectly from you. For example, from observing your actions on our website or interactions with our advertisers.</li>
          </ul>

          <h6>Use of Personal Information</h6>
          <p>We may use, or disclose the personal information we collect for one or more of the following business purposes:</p>
          <ul>
            <li>To fulfill or meet the reason you provided the information. For example, if you share your name and contact information to request a price quote or ask a question about our products or services, we will use that personal information to respond to your inquiry.</li>
            <li>To provide you with support and to respond to your inquiries, including to investigate and address your concerns and monitor and improve our responses.</li>
            <li>To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations.</li>
            <li>As described to you when collecting your personal information or as otherwise set forth in the CCPA.</li>
            <li>We will not collect additional categories of personal information or use the personal information we collected for materially different, unrelated, or incompatible purposes without providing you notice.</li>
          </ul>

          <h6>Sharing Personal Information</h6>
          <p>We may disclose your personal information to a third party for a business purpose; however, we do not sell your personal information. When we disclose personal information for a business purpose, we enter a contract that describes the purpose and requires the recipient to both keep that personal information confidential and not use it for any purpose except performing the contract. [The CCPA prohibits third parties who purchase the personal information we hold from reselling it unless you have received explicit notice and an opportunity to opt-out of further sales.]</p>

          <h6>Sales of Personal Information</h6>
          <p>In the preceding twelve (12) months, American Credit, Inc, has not sold personal information, nor do we ever sell personal information.</p>

          <h6>Your Rights and Choices</h6>
          <p>The CCPA provides consumers (California residents) with specific rights regarding their personal information. This section describes your CCPA rights and explains how to exercise those rights.</p>

          <h6>Access to Specific Information and Data Portability Rights</h6>
          <p>You have the right to request that we disclose certain information to you about our collection and use of your personal information over the past 12 months. Once we receive and confirm your verifiable consumer request, we will disclose to you:</p>
          <ul>
            <li>The categories of personal information we collected about you.</li>
            <li>The categories of sources for the personal inf ormation we collected about you.</li>
            <li>Our business or commercial purpose for collecting or selling that personal information.</li>
            <li>The categories of third parties with whom we share that personal information.</li>
            <li>The specific pieces of personal information we collected about you (also called a data portability request).</li>
            <li>If we sold or disclosed your personal information for a business purpose, two separate lists disclosing:</li>
            <ul>
              <li class="circle">sales, identifying the personal information categories that each category of recipient purchased;</li>
              <li class="circle">and disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained.</li>
            </ul>
          </ul>

          <h6>Deletion Request Rights</h6>
          <p>You have the right to request that we delete any of your personal information that we collected from you and retained, subject to certain exceptions. Once we receive and confirm your verifiable consumer request, we will delete (and direct our service providers to delete) your personal information from our records, unless an exception applies.</p>
          <p>We may deny your deletion request if retaining the information is necessary for us or our service provider(s) to:</p>
          <ul>
            <li>Complete the transaction for which we collected the personal information, provide a good or service that you requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, or otherwise perform our contract with you.</li>
            <li>Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities.</li>
            <li>Debug products to identify and repair errors that impair existing intended functionality.</li>
            <li>Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise another right provided for by law.</li>
            <li>Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.).</li>
            <li>Enable solely internal uses that are reasonably aligned with consumer expectations based on your relationship with us.</li>
            <li>Comply with a legal obligation.</li>
            <li>Make other internal and lawful uses of that information that are compatible with the context in which you provided it.</li>
          </ul>

          <h6>Exercising Access, Data Portability, and Deletion Rights</h6>
          <p>To exercise the access, data portability, and deletion rights described above, please submit a verifiable consumer request to us via email to <a href="mailto:info@amcredit.com">info@amcredit.com</a> or call <a href="tel:1855-904-0188">855-904-0188</a>.</p>
          <p>Only you, or a person registered with the California Secretary of State that you authorize to act on your behalf, may make a verifiable consumer request related to your personal information.</p>
          <p>You may only make a verifiable consumer request for access or data portability twice within a 12-month period. The verifiable consumer request must:</p>
          <ul>
            <li>Provide sufficient information that allows us to reasonably verify you are the person about whom we collected personal information or an authorized representative.</li>
            <li>Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it.</li>
          </ul>
          <p>We cannot respond to your request or provide you with personal information if we cannot verify your identity or authority to make the request and confirm the personal information relates to you. We will only use personal information provided in a verifiable consumer request to verify the requestor’s identity or authority to make the request.</p>
          
          <h6>Response Timing and Format</h6>
          <p>We endeavor to respond to a verifiable consumer request within forty-five (45) days of its receipt. If we require more time (up to [45/90] days), we will inform you of the reason and extension period in writing. We will deliver our written response electronically. Any disclosures we provide will only cover the 12-month period preceding the verifiable consumer request’s receipt. The response we provide will also explain the reasons we cannot comply with a request, if applicable. For data portability requests, we will select a format to provide your personal information that is readily useable and should allow you to transmit the information from one entity to another entity without hindrance, specifically by electronic mail communication.</p>
          <p>We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that decision and provide you with a cost estimate before completing your request.</p>
          
          <h6>Personal Information Sales Opt-Out and Opt-In Rights</h6>
          <p>If you are 16 years of age or older, you have the right to direct us to not sell your personal information at any time (the “right to opt-out”). Consumers who opt-in to personal information sales may opt-out of future sales at any time. To exercise the right to opt-out, you (or your authorized representative) may submit a request to us by visiting our CCPA Disclosure webpage and completing any of the options listed under the “How to Make a Request” section at the bottom of the page.</p>
          <p>Once you make an opt-out request, we will wait at least twelve (12) months before asking you to reauthorize personal information sales. However, you may change your mind and opt back into personal information sales at any time by visiting our website and completing any of the options in the “How to Make a Request” section on the CCPA Disclosure webpage. We will only use personal information provided in an opt-out request to review and comply with the request.</p>

          <h6>Non-Discrimination</h6>
          <p>We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not:</p>
          <ul>
            <li>Deny you goods or services.</li>
            <li>Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties.</li>
            <li>Provide you a different level or quality of goods or services.</li>
            <li>Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services.</li>
          </ul>

          <h6>Changes to Our Privacy Notice</h6>
          <p>We reserve the right to amend this privacy notice at our discretion and at any time. When we make changes to this privacy notice, we will post the updated notice on the website and update the notice’s effective date. Your continued use of our website following the posting of changes constitutes your acceptance of such changes.</p>
          
          <h6>Contact Information</h6>
          <p>If you have any questions or comment s about this notice, the ways in which we collect and uses your information described below [and in the Privacy Policy], your choices and rights regarding such use, or wish to exercise your rights under California law, please do not hesitate to contact us as follows</p>
          <ul>
            <li>Via our website: <a href="/contact-us">https://amcredit.com/contact-us</a></li>
            <li>Email: <a href="mailto:info@amcredit.com">info@amcredit.com</a></li>
            <li>Phone: <a href="tel:1855-904-0188">855-904-0188</a></li>
          </ul>
				  <br />
		    </div>
	    </div>
    </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
    mounted() {
      var seo = document.getElementById("seo")

      var meta=document.getElementById("seometa");
      if(!meta){
        meta=document.createElement("meta");
        meta.name="description";
        meta.id="seometa";
        document.head.insertBefore(meta,seo);
      }
      
      var keywords=document.getElementById("seokeywords");
      if(!keywords){
        keywords=document.createElement("meta");
        keywords.name="keywords";
        keywords.id="seokeywords"
        document.head.insertBefore(keywords,seo);
      }

      document.title="American Credit : Privacy"
      meta.content="American Credit : Privacy";
      keywords.content="American Credit, Privacy";
    }
	}
</script>
<style scoped lang="scss">
	.body-privacy {
		color: #5b5b5b;
		padding-top: 90px;
		font-size: 16px;
		.bg-privacy {
			background-color: #f6f6f6;
			h6 {
				font-weight: 600;
				margin-bottom: 0.75rem;
			}
			p {
				margin: 0 0 .75em;
			}
			ul {
				list-style-position: inside;
				text-indent: -10px;
				padding-left: 20px;
				margin-bottom: 20px;
				li:before {
					content: "● ";
    			color: #5b5b5b;
				}
				// li.dash:before {
					// content: "- ";
					// color: #5b5b5b;
				// }
        li.circle:before {
					content: "○ ";
					color: #5b5b5b;
				}
			}
		}	
	}

	.table-privacy-security {
		width: 100%;
		margin-bottom: 30px;
		border-collapse: separate;
		border-spacing: 0;
		border-right: 3px solid #fff;
		border-bottom: 3px solid #fff;
		border-width: 3px;
		tbody {
			background-color: #f6f6f6;
			border-width: 2px;
			tr:nth-child(even) {
				background-color: #e7f6fd;
			}
			tr:hover>td {
				color: #090909;
			}
			th, td {
				border-left: 3px solid #fff;
				border-top: 3px solid #fff;
				padding: 10px;
				font-size: 12px;
				background-color: transparent;
				color: #5b5b5b;
				text-align: center!important;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.body-privacy {
			padding-top: 0;
		}
	}

	@media screen and (min-width: 768px) {
		.table-privacy-security tbody td {
			font-size: 15px;
		}
		.table-privacy-security tbody th {
			font-size: 16px;
		}
	}

	@media screen and (min-width: 992px) {
		.table-privacy-security tbody td {
			font-size: 16px;
		}
	}
	
</style>



// WEBPACK FOOTER //
// privacyNoticeForCaliforniaResidents.vue?418beadd